import React, { useState } from 'react';
import { Save, CheckCircle, AlertCircle } from 'lucide-react';
import { getWorkspaceAccessToken, uploadFileToDrive } from '../lib/firebase';

interface Props {
  fileName: string;
  content: string;
}

export default function SaveToDriveButton({ fileName, content }: Props) {
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorText, setErrorText] = useState('');

  const handleSave = async () => {
    const accessToken = getWorkspaceAccessToken();
    if (!accessToken) {
      setErrorText('يرجى تسجيل الدخول باستخدام Google أولاً.');
      setStatus('error');
      return;
    }

    setStatus('loading');
    setErrorText('');
    
    const result = await uploadFileToDrive(accessToken, fileName, content);
    
    if (result.success) {
      setStatus('success');
      setTimeout(() => setStatus('idle'), 3000);
    } else {
      setStatus('error');
      setErrorText(result.error || 'فشل في حفظ الملف.');
    }
  };

  return (
    <button
      onClick={handleSave}
      disabled={status === 'loading'}
      className="flex items-center gap-1.5 text-xs text-blue-700 bg-blue-50 px-2 py-1 rounded border border-blue-200 hover:bg-blue-100 disabled:opacity-50"
    >
      {status === 'idle' && <Save className="w-3 h-3" />}
      {status === 'loading' && <span className="animate-spin">...</span>}
      {status === 'success' && <CheckCircle className="w-3 h-3 text-blue-600" />}
      {status === 'error' && <AlertCircle className="w-3 h-3 text-rose-600" />}
      <span>{status === 'idle' ? 'حفظ إلى Drive' : status === 'success' ? 'تم الحفظ!' : errorText}</span>
    </button>
  );
}
